// extracted by mini-css-extract-plugin
export default {"content":"content--z4Ktl","content-inner":"content-inner--l_0gd","contentInner":"content-inner--l_0gd"};